/* eslint-disable react-hooks/exhaustive-deps */
import 'animate.css';
import { useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Col, Row } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import classes from './View.module.scss';

import {
  CONFIGURE_VIEW,
  CUSTOMER_TYPE,
  INSIGHT_TYPE,
  INSIGHT_TYPE_CODE,
  NUMBER_ZERO,
  VIEW,
} from 'constants/constants';

import useDatadogRum from 'hooks/useDatadogRum';
import {
  getAllInsightBoards,
  getInsightViews,
} from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setCards,
  setCustomerInsightBoardId,
  setFilterInit,
  setFocusAccountChecked,
  setInsightType,
  setSelectedAccountId,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
} from 'store/customer/customerViewSlice';
import AdvanceSearch from '../../shared/customer/AdvanceSearch';
import CustomerDropdown from '../../shared/customer/CustomerDropdown';
import InsightBoardsList from './InsightBoardsList';

const ViewList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { addAction, addClickAction } = useDatadogRum();

  const insightBoards = useSelector(
    (state) => state?.CustomerView?.insightBoards
  );

  const insightType = useSelector((state) => state?.CustomerView?.insightType);

  const componentAccessList = useSelector(
    (state) => state?.Auth?.componentAccessList
  );
  const advanceSearchClicked = useSelector(
    (state) => state?.CustomerView?.advanceSearchClicked
  );

  const { unixId, roleId } = useSelector(
    (state) => state?.Auth?.userClaimObject
  );

  const itemClickHandler = async (insight) => {
    // Call Insight Views API
    const response = await getInsightViews(
      insight.Id,
      insight.insightType === INSIGHT_TYPE.SAMPLE
        ? INSIGHT_TYPE_CODE.SAMPLE
        : INSIGHT_TYPE_CODE.GENERAL
    );
    // Set All Insight View and Selected Insight View
    dispatch(setAllInsightView(response?.data?.result ?? []));
    dispatch(
      setSelectedInsightView(response?.data?.result?.[NUMBER_ZERO] ?? {})
    );

    dispatch(setSeletedView(CUSTOMER_TYPE.get(insight?.flag)));
    dispatch(setCards([]));
    dispatch(
      setSelectedCustomer({
        value: insight.accountId,
        label: insight.accountName,
        zip: insight.zip,
        veevaId: insight?.veevaId,
        flag: insight?.flag,
      })
    );
    let isPriorityAccount = insight?.isPriorityAccount === 'Y' ? true : false;
    dispatch(setSelectedAccountId(insight.accountId));
    dispatch(setCustomerInsightBoardId(insight.Id));
    dispatch(setInsightType(insight.insightType));

    dispatch(setFocusAccountChecked(isPriorityAccount));
    addAction(
      'CUSTOMER_VIEW',
      { viewName: CUSTOMER_TYPE.get(insight.flag) },
      {
        timestamp: new Date().toISOString(),
        navigationSource: 'click-on-customer-view-icon',
        clickTarget: 'customer-view',
        page: 'customer-view-detail',
        view: CUSTOMER_TYPE.get(insight.flag),
        customerId: insight.accountId,
        customerName: insight.accountName,
      }
    );
  };

  const onChangeHandler = (selected) => {
    dispatch(setSelectedCustomer(selected));
    dispatch(setSeletedView(CUSTOMER_TYPE.get(selected?.flag)));
    navigate(`${encodeURIComponent(selected?.label)}`);
    addAction(
      'CUSTOMER_VIEW',
      { viewName: CUSTOMER_TYPE.get(selected.flag) },
      {
        timestamp: new Date().toISOString(),
        navigationSource: 'click-on-customer-view-icon',
        clickTarget: 'customer-view',
        page: 'customer-view-detail',
        view: CUSTOMER_TYPE.get(selected.flag),
        customerId: selected.value,
        customerName: selected.label,
      }
    );
  };

  const handleTabChange = (k) => {
    dispatch(setInsightType(k));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setFilterInit());
    dispatch(getAllInsightBoards(unixId, roleId));
    dispatch(setSelectedCustomer([]));
    addClickAction({
      viewName: 'CUSTOMER_VIEW_LIST',
      navigationSource: 'click-on-customer-view-icon',
      clickTarget: 'customer-view',
      page: 'customer-view-landing',
      view: 'CUSTOMER_VIEW_LIST',
    });
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));

    // Reset Selected Insight view and All views
    dispatch(setSelectedInsightView({}));
    dispatch(setAllInsightView([]));
  }, []);

  return (
    <>
      <Row className={classes['title-container']}>
        <Col
          className='p-0'
          md={12}
          xs={9}>
          <Fade>
            <p className='title__bold title__medium me-3 animate__animated animate__fadeIn mb-2'>
              <i className='icon icon__customer-view--title'></i>
              Customer View
            </p>
            <p className='title title__small'>
              Select a customer from the dropdown to begin exploration. Please
              note that an Insight Board will only be created upon adding custom
              tiles or views.
            </p>
          </Fade>
          {/* account type */}
          <div className={`${classes['account-dropdown']}`}>
            <Row>
              <Col
                md={9}
                xs={12}
                className='mt-1 mb-2'>
                <div className={classes['dropdown-container']}>
                  <CustomerDropdown
                    page={CONFIGURE_VIEW.viewList}
                    viewName={VIEW.customer}
                    onChangeHandler={onChangeHandler}
                    focusDisabled={false}
                    focusChecked={true}
                    isDisabled={false}
                  />
                </div>
              </Col>
              <Col
                md={3}
                xs={12}
                className='mt-5'>
                {/* configure priority link */}
                {componentAccessList?.includes(
                  'Customer-View-Configure-Priority'
                ) && (
                  <div className={classes['configure-container']}>
                    <Link
                      to='/configure-priority'
                      className='d-flex align-items-center ms-3'>
                      <i className='icon icon__configure'></i>{' '}
                      <span
                        className={`text__bold text__small ${classes['configure-label']}`}>
                        Configure Priority
                      </span>
                    </Link>
                  </div>
                )}
              </Col>
            </Row>
            {advanceSearchClicked[CONFIGURE_VIEW.viewList] && (
              <Row className='animate__animated animate__fadeIn search-container customerView w-100'>
                <AdvanceSearch page={CONFIGURE_VIEW.viewList} />
              </Row>
            )}
          </div>
        </Col>
      </Row>

      <Fade>
        <Row className={`${classes['insights-header-container']}`}>
          <Col className='animate__animated animate__fadeIn p-0 mt-4'>
            {/* insights board Title */}
            <p className='title__bold title__medium mb-4'>
              <i className='icon icon__insight-board-title'></i>
              Insight Boards
            </p>
          </Col>
        </Row>
      </Fade>

      <Row>
        <Col className='p-0'>
          <Tabs
            activeKey={insightType}
            onSelect={handleTabChange}
            unmountOnExit={true}
            mountOnEnter={true}
            className={`mb-3 ps-0 ${classes.stickyTab}`}>
            <Tab
              eventKey='general'
              title={<span className='d-flex'>My Insight Boards</span>}>
              <InsightBoardsList
                page={insightType}
                insightBoards={insightBoards}
                onItemClickHandler={itemClickHandler}
              />
            </Tab>
            <Tab
              eventKey='sample'
              title={<span className='d-flex'>Sample Insight Boards</span>}>
              <InsightBoardsList
                page={insightType}
                insightBoards={insightBoards}
                onItemClickHandler={itemClickHandler}
              />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default ViewList;
